import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, Typography } from '@totalsoft/rocket-ui';
import { get, set } from '@totalsoft/change-tracking-react';
import TransitionUserGroupListComponent from './TransitionUserGroupListComponent';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import LabeledCheckbox from 'components/common/inputs/LabeledCheckbox';
import { FlowPermissionType, useFlowPermissions } from '../hooks';
import { usePermissions } from 'providers/RightsHooks';

const GenericEntityFlowEditTransitionsComponent = ({ flowId, businessStates, transition, userGroups, transitionsValidation, index }) => {
  const { t } = useTranslation();

  const authorizationCode = useFlowPermissions(FlowPermissionType.WRITE);
  const canWrite = usePermissions(authorizationCode);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={3}>
        <Autocomplete
          fullWidth
          simpleValue={true}
          valueKey='stateId'
          labelKey='stateName'
          label={t('GenericEntityFlow.InitialState')}
          value={transition.initialStateId |> get}
          onChange={transition.initialStateId |> set}
          options={businessStates}
          error={!isValid(transitionsValidation[index].initialStateId)}
          helperText={getErrors(transitionsValidation[index].initialStateId)}
          disabled={!canWrite}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Autocomplete
          fullWidth
          label={t('GenericEntityFlow.FinalState')}
          simpleValue={true}
          value={transition.finalStateId |> get}
          onChange={transition.finalStateId |> set}
          options={businessStates}
          valueKey='stateId'
          labelKey='stateName'
          error={!isValid(transitionsValidation[index].finalStateId)}
          helperText={getErrors(transitionsValidation[index].finalStateId)}
          disabled={!canWrite}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <LabeledCheckbox
          checked={Boolean(transition.allowedForAllUserGroups |> get)}
          label={t('GenericEntityFlow.AllGroups')}
          onChange={transition.allowedForAllUserGroups |> set}
          disabled={!canWrite}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <LabeledCheckbox
          checked={Boolean(transition.fourEyesPrinciple |> get)}
          label={t('GenericEntityFlow.FourEyesPrinciple')}
          onChange={transition.fourEyesPrinciple |> set}
          disabled={!canWrite}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography color='error'>{getErrors(transitionsValidation)}</Typography>
      </Grid>
      <Grid item xs={12} mt={-2}>
        <TransitionUserGroupListComponent flowId={flowId} transitionLens={transition} userGroups={userGroups} />
      </Grid>
    </Grid>
  );
};

GenericEntityFlowEditTransitionsComponent.propTypes = {
  flowId: PropTypes.number,
  businessStates: PropTypes.array,
  transition: PropTypes.object,
  userGroups: PropTypes.array,
  transitionsValidation: PropTypes.object,
  index: PropTypes.number
};

export default React.memo(GenericEntityFlowEditTransitionsComponent);
